<template>
    <v-layout class="no-search-results" column >
            <v-layout column class="no-search-results" >
                <v-flex class="no-search-results__search-text">
                    {{`${capitalizeFirstLetter(searchText)}?`}}
                </v-flex>
                <v-flex  class="no-search-results__message">
                    {{globalSearchConstants.WE_SEARCHED_IN}}
                </v-flex>
                <v-flex class="no-search-results__message">
                    {{`${globalSearchConstants.COULD_NOT_FIND} ${capitalizeFirstLetter(searchText)}`}}
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-space-between class="no-search-results__images">
                    <v-flex xs6 sm3 class="no-search-results__image" @click="routeTo(routerNames.MEMBER_DIRECTORY_PAGE)" >
                        <v-img :src="require('../../assets/YpoSearch/interstitial_logo_people.png')"></v-img>
                        <p class="no-search-results__image--caption">{{globalSearchConstants.BROWSE_ALL_PEOPLE}} </p>
                    </v-flex>
                    <v-flex xs6 sm3 class="no-search-results__image" @click="routeTo(routerNames.EVENT_DIRECTORY_PAGE)" >
                        <v-img :src="require('../../assets/YpoSearch/interstitial_logo_events.png')"></v-img>
                        <p class="no-search-results__image--caption">{{globalSearchConstants.BROWSE_ALL_EVENTS}} </p>
                    </v-flex>
                    <v-flex xs6 sm3 class="no-search-results__image" @click="routeTo(routerNames.COMMUNITY_DIRECTORY_PAGE)" >
                        <v-img :src="require('../../assets/YpoSearch/interstitial_logo_communities.png')"></v-img>
                        <p class="no-search-results__image--caption">{{globalSearchConstants.BROWSE_ALL_COMMUNITIES}} </p>
                    </v-flex>
                    <v-flex xs6 sm3 class="no-search-results__image" @click="routeTo(routerNames.CONTENT_DIRECTORY_PAGE)" >
                        <v-img :src="require('../../assets/YpoSearch/interstitial_logo_contents.png')"></v-img>
                        <p class="no-search-results__image--caption">{{globalSearchConstants.BROWSE_ALL_CONTENT}} </p>
                    </v-flex>
            </v-layout>

            <v-layout class="no-search-results__contact-us" column align-end>
                <v-flex class="no-search-results__contact-us__not-found">
                    {{`${globalSearchConstants.UNABLE_TO_FIND}${" " + capitalizeFirstLetter(searchText)}?&nbsp`}}
                    <v-tooltip bottom color="ypo_light_gray">
                        <template v-slot:activator="{ on }">
                            <a v-on="on" :href="`mailto: ${globalSearchConstants.ASK_YPO}`" class="no-search-results__contact-us__text">
                            {{globalSearchConstants.CONTACT_US}}
                            </a>
                        </template>
                        <span class="no-search-results__contact-us__not-found--tooltip-message">{{globalSearchConstants.ASK_YPO}}</span>
                    </v-tooltip>
                </v-flex>
            </v-layout>
    </v-layout>
</template>

<script>
    import { globalSearchConstants } from "./ypoSearch.constants";
    import { routerNames } from "../appCommon.constants";
    import { eventDirectoryPageConstant } from "../EventDirectoryPage/eventDirectoryPage.constants";
    import { appConstant } from "../../app.constant";

    export default {
        name: 'NoResultFound',
        props: {
            searchText: {
                required: true,
                type: String,
            },
            postSelectCallback: {
                type: Function,
                required: true,
            },
        },
        data() {
            return {
                globalSearchConstants,
                routerNames,
                appConstant,
                eventDirectoryPageConstant,
                defaultFilterKey: eventDirectoryPageConstant.constant.myChapterDefaultFilter.parentKey,
            };
        },
        methods: {
            routeTo(path) {
                if (this.postSelectCallback) this.postSelectCallback();
                if (path === routerNames.EVENT_DIRECTORY_PAGE) {
                    const eventFiltersFromStorage = sessionStorage.getItem(appConstant.storageKeys.eventDirectoryStoredFilters);
                    let eventFilters = eventFiltersFromStorage ? JSON.parse(eventFiltersFromStorage) : "";
                    const hasOtherFilters = Object.keys(eventFilters).some(key => !!key.length);
                    eventFilters = hasOtherFilters || this.$route.name === routerNames.EVENT_DIRECTORY_PAGE
                        ? {
                            ...eventFilters,
                        }
                        : {
                            ...eventFilters,
                            [this.defaultFilterKey]: [eventDirectoryPageConstant.constant.myChapterDefaultFilter.filter],
                        };
                    this.$router.push({
                        path: `/${routerNames.EVENT_DIRECTORY_PAGE}`,
                        query: {
                            eventFilters: JSON.stringify(eventFilters),
                        },
                    });
                } else {
                    this.$router.push({
                        path: `/${path}`,
                    });
                }
            },
            capitalizeFirstLetter(word) {
                const firstLetter = word.charAt(0).toUpperCase();
                const restOfTheLetters = word.slice(1, word.length);
                return `${firstLetter}${restOfTheLetters}`;
            },

        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_commonClasses.scss";
    @import "../../common/styles/_responsive.scss";

    .no-search-results {
        &__search-text {
            text-align: left;
            margin-top: 83px;
            margin-bottom: 10px;
            color: $ypo-cta;
            font-size: 20px;
            font-weight: 600;
            line-height: 22px;
            font-family: Raleway;
        }

        &__message {
            text-align: left;
            color: #222222;
            font-family: Raleway;
            font-size: 17px;
            font-style: italic;
            font-weight: 500;
            line-height: 22px;
        }

        &__image {
            cursor: pointer;
            margin-top: 50px;
            border-radius: 4px;
            max-height: 100px;
            max-width: 100px;

            &--caption {
                height: 34px;
                color: $ypo-cta;
                font-family: Raleway;
                font-size: 14px;
                font-weight: 600;
                letter-spacing: 0.42px;
                line-height: 17px;
                text-align: center;
            }
        }


        &__contact-us{
            margin-top: 7rem;

            &__not-found {
                font-style: italic;
                color: $black;
                font-size: 14px;

                &--tooltip-message {
                    color: $black;
                }
            }

            &__text {
                font-style: normal;
                height: 20px;
                width: 264px;
                color: $ypo-cta;
                font-family: Raleway;
                font-size: 14px;
                font-weight: 600;
                line-height: 20px;
                margin-right: .5rem;
                text-decoration: none;
            }
        }
    }

</style>
